import React from "react";
import { Link } from "react-router-dom";
//import Rating from './Rating';

export default function SearchedRecord(props) {
  const { record } = props;
  return (
    <div key={record._id} className="card">
      <Link to={`/records/${record._id}/edit`}>
        {/*   <!--image size: 680px by 830px -->
                  <img className="medium" src={ record.image }alt={record.name} /> */}
      </Link>
      <div className="card-body">
        <Link to={`/records/${record._id}/edit`}>
          <h5>{record.description}</h5>
          <h6>{record.paydate}</h6>
          <h6>{record.category}</h6>
          <h6>{record.paymentmethod}</h6>
          <div className="price">${record.invoiceamount}</div>
        </Link>
      </div>
    </div>
  );
}
